import React from "react";
import { Image } from 'antd';


function ImageDemo() {
  return (
    <Image
      width={200}
      src="https://avatars1.githubusercontent.com/u/5441280?v=4"
      alt="Mosh Hamedani"
    />
  );
}

export default ImageDemo;